
<template>
  <div
    :class="{ disabledbutton: autoCompleteInputDisable && !variable.is_index }"
    :key="key"
  >
    <!-- {{ variable.type === 'date' ? variable : '' }} -->
    <!-- <label for="">{{variable}}</label> -->
    <inputText
      v-if="variable.type === 'text' || variable.type === 'alphanumeric'"
      :variable="variable"
      :key="variable.idk"
      :id="variable.idk"
      :ref="`variable-${variable.variable}`"
      :name="sanitize(variable.label)"
      :label="variable.label"
      type="text"
      :validate="
        isComponent || isPreview
          ? {}
          : {
              min: parseInt(variable.config.minimumLength),
              max: variable.config.maximumLength
                ? parseInt(variable.config.maximumLength)
                : 99999,
              required: 'required' in variable.extra_config ? true : false,
            }
      "
      :validationMode="isPreview ? 'passive' : 'aggressive'"
      autocomplete="off"
      :value.sync="variable.value"
      :placeholder="variable.description"
      :isFormsearchAutocomplete="variable.is_index && isFormFill"
      :searchbutton="
        variable.is_index && isFormFill ? findDataAutocomplete : () => {}
      "
      :families="variable.is_index && isFormFill ? familiesData : {}"
    />
    <inputText
      v-else-if="variable.type === 'integer'"
      :variable="variable"
      :key="variable.id"
      :id="variable.idk"
      :ref="`variable-${variable.variable}`"
      :name="sanitize(variable.label)"
      :label="variable.label"
      type="number"
      :validate="
        isComponent || isPreview
          ? {}
          : {
              minmax: [
                parseInt(variable.config.minimumValue),
                parseInt(variable.config.maximumValue),
              ],
              required: 'required' in variable.extra_config ? true : false,
            }
      "
      :validationMode="isPreview ? 'passive' : 'aggressive'"
      autocomplete="off"
      :value.sync="variable.value"
      :placeholder="variable.description"
    />
    <inputText
      v-else-if="variable.type === 'decimal'"
      :variable="variable"
      :id="variable.idk"
      :ref="`variable-${variable.variable}`"
      :name="sanitize(variable.label)"
      :label="variable.label"
      type="number"
      :validate="
        isComponent || isPreview
          ? {}
          : {
              minmax: [
                parseInt(variable.config.minimumValue),
                parseInt(variable.config.maximumValue),
              ],
              required: 'required' in variable.extra_config ? true : false,
              regex: /(^[-|\+|0-9][0-9]*)(\.*)[0-9]*$/,
            }
      "
      :validationMode="isPreview ? 'passive' : 'aggressive'"
      autocomplete="off"
      :value.sync="variable.value"
      :placeholder="variable.description"
    />
    <inputCheckbox
      v-else-if="variable.type === 'boolean'"
      :id="variable.idk"
      :ref="`variable-${variable.variable}`"
      :name="sanitize(variable.label)"
      :label="variable.label"
      :validationMode="isPreview ? 'passive' : 'aggressive'"
      :validate="
        isComponent || isPreview
          ? {}
          : { required: 'required' in variable.extra_config ? true : false }
      "
      :value.sync="checked"
      @change="validarBoolean"
      :innerLabel__="variable.description"
      innerLabel="No / Si"
    />
    <inputText
      v-else-if="variable.type === 'email'"
      :variable="variable"
      :id="variable.idk"
      :ref="`variable-${variable.variable}`"
      :name="sanitize(variable.label)"
      :label="variable.label"
      type="text"
      :validate="
        isComponent || isPreview
          ? {}
          : {
              email: true,
              required: 'required' in variable.extra_config ? true : false,
            }
      "
      :validationMode="isPreview ? 'passive' : 'aggressive'"
      autocomplete="off"
      :value.sync="variable.value"
      :placeholder="variable.description"
    />
    <inputMultiSelect
      v-else-if="variable.type === 'list'"
      :id="variable.idk"
      :ref="`${variable.variable}`"
      :name="sanitize(variable.label)"
      :label="variable.label"
      :validationMode="isPreview ? 'passive' : 'aggressive'"
      :options="variable.config.listOptions"
      :validate="
        isComponent || isPreview
          ? {}
          : { required: 'required' in variable.extra_config ? true : false }
      "
      trackBy="key"
      :multiple="variable.config.isMultiple === 1 ? true : false"
      :custom-label="(t) => t.value"
      :value.sync="variable.value"
      :placeholder="variable.description"
      :onclick="clickInit"
    />
    <div v-else-if="variable.type === 'date' && variable.mode === 'report'">
      <label
        :for="variable.idk"
        :class="`font-weight-bold ${
          'required' in variable.extra_config ? 'is-required' : ''
        }`"
        >{{ variable.label }}</label
      >
      <DatePicker
        timezone="UTC"
        v-model="variable.value"
        mode="date"
        :masks="{ input: 'YYYY-MM-DD' }"
        :columns="2"
        :popover="{ placement: 'bottom', visibility: 'click' }"
        is-range
      >
        <template v-slot="{ inputValue, inputEvents, isDragging }">
          <div class="flex flex-col sm:flex-row justify-start items-center">
            <b-row>
              <b-col md="12" class="px-0">
                <div class="relative flex-grow">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text class="d-none d-xl-block">
                        <i class="far fa-calendar" />
                      </b-input-group-text>
                    </template>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="AAAA-MM-DD"
                      :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                      :value="inputValue.start"
                      v-on="inputEvents.start"
                      autocomplete="off"
                    />
                    <input
                      type="text"
                      class="form-control"
                      placeholder="AAAA-MM-DD"
                      :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                      :value="inputValue.end"
                      v-on="inputEvents.end"
                      autocomplete="off"
                    />
                  </b-input-group>
                </div>
              </b-col>
            </b-row>
          </div>
        </template>
      </DatePicker>
    </div>
    <inputDatepicker
      v-else-if="variable.type === 'date'"
      :id="`${variable.idk}`"
      :ref="`variable-${variable.variable}`"
      :name="sanitize(variable.label)"
      :label="variable.label"
      type="text"
      :validate="
        isComponent || isPreview
          ? {
              regex:
                /^(19[0-9]{2}|2[0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12]\d|3[0-1]))|(02-(0[1-9]|[12]\d))|((0[469]|11)-(0[1-9]|[12]\d|30)))$/,
            }
          : {
              regex:
                /^(19[0-9]{2}|2[0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12]\d|3[0-1]))|(02-(0[1-9]|[12]\d))|((0[469]|11)-(0[1-9]|[12]\d|30)))$/,
              required: 'required' in variable.extra_config ? true : false,
            }
      "
      :min="
        variable.config.minimumDate !== ''
          ? new Date(variable.config.minimunDate)
          : null
      "
      :initial-date="
        'fromToday' in variable.config
          ? parseInt(variable.config.fromToday) === 1
            ? today
            : null
          : null
      "
      :validationMode="isPreview ? 'passive' : 'aggressive'"
      :value.sync="variable.value"
      :placeholder="variable.description"
    />
    <div v-else-if="variable.type === 'time'">
      <label
        :for="`${variable.idk + 0.1}`"
        :class="`font-weight-bold ${
          'required' in variable.extra_config ? 'is-required' : ''
        }`"
        >{{ variable.label }}</label
      >
      <b-form-timepicker
        :id="variable.idk"
        :ref="`variable-${variable.variable}`"
        :name="sanitize(variable.label)"
        :label="variable.label"
        :custom-label="(t) => t.value"
        locale="es"
        hide-header
        v-model="variable.value"
        label-close-button="Cerrar"
        :placeholder="variable.description"
      />
    </div>
    <div v-else-if="variable.type === 'address'">
      <ModalAddress :idmodal="variable.idk" :value.sync="variable.value" />
      <label
        :for="variable.id"
        :class="`font-weight-bold ${
          'required' in variable.extra_config ? 'is-required' : ''
        }`"
        >{{ variable.label }}</label
      ><br />
      <b-button
        :id="`${variable.id}`"
        :ref="`variable-${variable.variable}`"
        :name="sanitize(variable.label)"
        variant="primary"
        @click="$bvModal.show(`address-modal${variable.idk}`)"
      >
        {{ variable.value ? 'Editar' : 'Ingrese dirección' }} </b-button
      ><span class="ml-1 mt-1 text-muted d-inline-block">{{
        variable.value
      }}</span
      ><br />
      <small>{{ variable.description }}</small>
    </div>
    <div v-else-if="variable.type === 'pdf' || variable.type === 'file'">
      <inputFile
        :config="variable"
        :id="variable.idk"
        :ref="`variable-${variable.variable}`"
        :name="sanitize(variable.label)"
        :label="variable.label"
        :validate="
          isComponent || isPreview
            ? {}
            : {
                ext: variable.config.acceptExtensions
                  ? variable.config.acceptExtensions
                      .replaceAll('.', '')
                      .replaceAll(' ', '')
                      .split(',')
                      .filter((x) => x !== '')
                  : false,
                size: variable.config.maximumSize
                  ? parseInt(variable.config.maximumSize)
                  : false,
                required: 'required' in variable.extra_config && variable.extra_config.required==1? true : false,
              }
        "
        :placeholder="variable.description"
        :validationMode="isPreview ? 'passive' : 'aggressive'"
        :value.sync="variable.value"
      />
    </div>
    <div v-else-if="variable.type === 'image'">
      <inputFile
        :config="variable"
        :id="variable.idk"
        :ref="`variable-${variable.variable}`"
        :name="sanitize(variable.label)"
        :label="variable.label"
        :validate="
          isComponent || isPreview
            ? {}
            : {
                ext: variable.config.acceptExtensions
                  ? variable.config.acceptExtensions
                      .replaceAll('.', '')
                      .replaceAll(' ', '')
                      .split(',')
                      .filter((x) => x !== '')
                  : false,
                size: variable.config.maximumSize
                  ? parseInt(variable.config.maximumSize)
                  : false,
                required: 'required' in variable.extra_config ? true : false,
              }
        "
        :placeholder="variable.description"
        :validationMode="isPreview ? 'passive' : 'aggressive'"
        :value.sync="variable.value"
      />
    </div>
    <div v-else class="text-muted">
      Pendiente variable tipo <b>{{ variable.type }}</b
      ><br /><code>{{ variable }}</code>
    </div>
    <div v-if="isComponent" class="required-section text-right pt-2 pb-0">
      <b-form-checkbox
        v-if="hiddenRequired"
        v-model="variable.extra_config.required"
        name="variable-required"
        switch
      >
        <span class="font-weight-normal">Obligatorio</span>
      </b-form-checkbox>
      <b-button
        v-if="removeButton"
        @click="$emit('remove')"
        variant="transparent"
        class="inline-block"
        v-b-tooltip.hover="{ variant: 'info', title: 'Eliminar variable' }"
      >
        <b-icon icon="trash" font-scale="1.3"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import InputText from '@components/form/InputText'
import InputTextarea from '@components/form/InputTextarea'
import InputFile from '@components/form/InputFile'
// import InputSelect from '@components/form/InputSelect'
import InputMultiSelect from '@components/form/InputMultiSelect'
import InputDatepicker from '@components/form/InputDatepicker'
import InputRadio from '@components/form/InputRadio'
import InputCheckbox from '@components/form/InputCheckbox'
import ModalAddress from '@components/form/modalAddress'
import { DatePicker } from 'v-calendar'

export default {
  name: 'renderVariable',
  components: {
    InputText,
    InputTextarea,
    InputFile,
    InputRadio,
    InputMultiSelect,
    InputCheckbox,
    ModalAddress,
    DatePicker,
    InputDatepicker,
  }, // InputSelect,
  props: {
    familiHome:{
      type: Object,
      required:false,
      default:[]
    },
    key: {
      type: Number,
      required: false,
    },
    variable: {
      type: Object,
      required: true,
    },
    isFormFill: {
      type: Boolean,
      default: false,
    },
    isComponent: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    autoCompleteInputDisable: {
      type: Boolean,
      default: false,
    },
    removeButton: {
      type: Boolean,
      default: false,
    },
    validateDependents: {
      type: Function,
      default: () => {},
    },
    findDataAutocomplete: {
      type: Function,
      required: false,
      default: () => {},
    },
    hiddenRequired: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    return {
      today: new Date(today),
      checked: false,
      key: now,
    }
  },
  methods: {
    sanitize(value) {
      return value
        .replace(new RegExp(' ', 'gi'), '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
    },
    clickInit(e) {
      this.variable.idk =( this.variable.idk || this.variable.id) +1
      this.validateDependents(this.variable)
    },
    validarBoolean(){
      this.validateDependents(this.variable)
    }
  },
  mounted() {
    // console.log("families",this.families)
    let _ = this
    if (_.variable.type === 'boolean') {
      if ('defaultValue' in _.variable.config) {
        _.$nextTick(() => {
          _.variable.value = _.variable.config.defaultValue == 1
          _.checked = _.variable.config.defaultValue == 1
        })
      }
    }
    if(_.variable.description === 'Código de Familia'){
          _.variable.value = this.familiHome.codigo_hogar
    }
    // PARA TRAER LAS FECHAS POR DEFECTO. LO QUITO PORQUE SIEMPRE APLICARIA FECHAS Y ENREDARÍA AL USUARIO
    // } else if (_.variable.type === 'date' && _.variable.mode === 'report'){
    //     _.variable.value = {
    //         start: moment(_.today).subtract(7, 'd').toDate(),
    //         end: moment(_.today).toDate()
    //     }
    // }
  },
  watch: {
    'variable.value'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.validateDependents(this.variable)
      }
    },
    checked(newVal, oldVal) {
      this.variable.value = newVal
      this.validarBoolean()
    },
  },
}
</script>

<style lang="scss" >
.dependent .required-section {
  border-top: 1px dashed #f7b84b;
}

.required-section {
  margin-top: 10px;
  border-top: 1px dashed #48c0f5;
  .custom-switch {
    display: inline;
    margin-right: 5px;
  }
}
.disabledbutton {
  pointer-events: none;
  opacity: 0.08;
  // display: none;
}
</style>